import {
  configureStore,
  ThunkAction,
  Action,
  combineReducers,
} from "@reduxjs/toolkit";
import { connectRouter, routerMiddleware } from "connected-react-router";
import { history } from "./history";
import appReducer from "../AppSlice";
import homeReducer from "../pages/Home/HomeSlice";
import confirmationReducer from "../pages/Confirmation/ConfirmationSlice";
import paymentReducer from "../pages/Payment/PaymentSlice";
import adminLoginReducer from "../pages/Admin/AdminLogin/AdminLoginSlice";
import adminSettingsReducer from "../pages/Admin/AdminSettings/AdminSettingsSlice";

const defaultMiddlewareConfig = {
  serializableCheck: {
    ignoredPaths: [],
    ignoredActions: [],
  },
};

const rootReducers = combineReducers({
  router: connectRouter<unknown>(history),
  app: appReducer,
  home: homeReducer,
  confirmation: confirmationReducer,
  payment: paymentReducer,
  admin: combineReducers({
    login: adminLoginReducer,
    settings: adminSettingsReducer,
  }),
});

export const store = configureStore({
  reducer: rootReducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware(defaultMiddlewareConfig).concat(
      routerMiddleware(history)
    ),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
